import { Navigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../store/auth-context";
import FullScreenLoader from "../common/FullScreenLoader/FullScreenLoader";
import { rolePermissions } from "./rolePermissions";

const ProtectedRoute = ({ children }) => {
  const authContext = useContext(AuthContext);
  const currentPath = window.location.pathname.split("/verifier/")[1] || "";

  if (authContext.isLoading) {
    return <FullScreenLoader />;
  }

  if (!authContext.isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  const userRole =
    authContext.userType?.toLowerCase() ||
    localStorage.getItem("userType")?.toLowerCase();
  if (!userRole) {
    return <Navigate to="/" replace />;
  }

  const allowedPaths = rolePermissions[userRole] || [];
  const isPathAllowed = allowedPaths.some((allowedPath) => {
    if (allowedPath === currentPath) return true;
    if (allowedPath.includes(":")) {
      const regex = new RegExp(`^${allowedPath.replace(/:[^/]+/g, "[^/]+")}$`);
      return currentPath.match(regex);
    }
    return false;
  });

  if (!isPathAllowed) {
    return <Navigate to="/verifier/validate" replace />;
  }

  return children;
};

export default ProtectedRoute;
